<template>
  <div class="ElasticBlockStoreDetail">
    <div class="ElasticBlockStoreDetail-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/elasticBlockStoreMonitor">{{
          $t("alarms.disk.disk")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Row type="flex" justify="space-between" class="code-row-bg">
      <Col span="6">
        <Card style="height: 480px;">
          <Row>
            <Row style="height: 200px;">
              <Col
                span="24"
                style="text-align: center;font-size: 103px;display: block;margin-top: 8px;"
              >
                <img :src="protectEasyLogo" style="width: 83px;" />
              </Col>
              <Col style="text-align: center;font-size:18px;">{{
                this.$route.query.name
              }}</Col>
            </Row>

            <Row style="margin-bottom: 20px;">
              <Col>{{ $t("alarms.disk.diskDescription") }}</Col>
              <Col>---</Col>
            </Row>
            <Row>
              <Col style="margin-bottom: 8px;">{{
                $t("alarms.disk.diskInformation")
              }}</Col>
              <Row>
                <Col span="12">{{ $t("alarms.disk.diskConfig") }}:</Col>
                <Col span="10">{{ this.$route.query.accountTypeName }}</Col>
              </Row>
            </Row>
          </Row>
        </Card>
      </Col>
      <Col span="13">
        <Card style="height: 480px;">
          <ul class="content">
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-laptop"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.disk.diskInformation") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.disk.diskId") }}</li>
                            <li>{{ this.$route.query.volumeAwsId }}</li>
                          </ul>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-pulse"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.monitorMessage") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.monitorItems") }}：</li>
                            <li>
                              {{ monitoringNum }}{{ $t("alarms.common.count") }}
                            </li>
                          </ul>
                        </Col>
                        <Col>
                          <a
                            @click="monitorEC"
                            v-hasPermission="[
                              'monitor:elasticBlockStoreDetail:overview'
                            ]"
                            >{{ $t("alarms.common.viewMonitoringOverview") }}</a
                          >
                        </Col>
                        <Col v-if="this.$route.query.accountTypeName == 'AWS'">
                          <a @click="handleViewForecastMonitoringOverview">{{
                            $t("alarms.common.viewForecastMonitoringOverview")
                          }}</a>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
            <li>
              <Row>
                <Col span="12">
                  <Col span="4">
                    <Button shape="circle" icon="ios-medkit-outline"></Button>
                  </Col>
                  <Col span="20">
                    <Row>
                      <Col>{{ $t("alarms.common.alertRule") }}</Col>
                      <Row class="host">
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.alertRule") }}：</li>
                            <li>{{ priorityNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <ul>
                            <li>{{ $t("alarms.common.untreated") }}：</li>
                            <li>{{ statusNum }}</li>
                          </ul>
                        </Col>
                        <Col>
                          <a
                            @click="alertRule"
                            v-hasPermission="[
                              'monitor:elasticBlockStoreDetail:alert_rule'
                            ]"
                            >{{ $t("alarms.common.viewAlarmRules") }}</a
                          >
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </li>
          </ul>
        </Card>
      </Col>
      <Col span="4">
        <Card style="height: 480px;">
          <Row>
            <Row style="margin-bottom: 10px;">
              <Col>{{ $t("alarms.common.tags") }}</Col>
            </Row>
            <Row>
              <Col v-for="(item, index) in tagList" v-bind:key="index">
                <Tag color="default">{{ item.key }} : {{ item.value }}</Tag>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import utils from "../../../utils/utils.js";
export default {
  name: "ElasticBlockStoreDetail",
  data() {
    return {
      id: "",
      accountId: "",
      volumeAwsId: "",
      awsZone: "",
      instanceId: "",
      accountTypeName: "",
      accountName: "",
      region: "",
      name: "",
      priorityNum: "",
      statusNum: "",
      monitoringNum: "",
      tagList: [],
      protectEasyLogo: require("../../../../static/images/ebs.png")
    };
  },
  mounted() {
    this.queryVolumeByVolumeId();
  },
  methods: {
    init: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.volumeAwsId = this.$route.query.volumeAwsId;
      this.awsZone = this.$route.query.awsZone;
      this.instanceId = this.$route.query.instanceId;
      this.region = this.$route.query.region;
      this.accountName = this.$route.query.accountName;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.name = this.$route.query.name;
    },
    // 通过instanceId查询实例
    queryVolumeByVolumeId: function() {
      this.$api.volume
        .queryVolumeByVolumeId({
          accountId: this.$route.query.accountId,
          volumeId: this.$route.query.volumeAwsId,
          region: this.$route.query.region,
          awsZone: this.$route.query.awsZone
        })
        .then(res => {
          this.statusNum = res.data.statusNum;
          this.monitoringNum = res.data.monitoringNum;
          this.priorityNum = res.data.priorityNum;
        });
    },
    // 点击查看监控概览
    monitorEC: function() {
      this.init();
      this.$router.push({
        path: "/monitor/ebs/",
        query: {
          id: this.id,
          accountId: this.accountId,
          volumeAwsId: this.volumeAwsId,
          instanceId: this.instanceId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
          awsZone: this.awsZone
        }
      });
    },
    // 点击查看报警规则
    alertRule: function() {
      this.init();
      this.$router.push({
        path: "/monitor/elasticBlockStoreWarning/",
        query: {
          id: this.id,
          accountId: this.accountId,
          volumeAwsId: this.volumeAwsId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    },
    // 查看预测监控概况
    handleViewForecastMonitoringOverview() {
      this.init();
      this.$router.push({
        path: "/monitor/ebsForecast/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.volumeAwsId,
          region: this.region,
          // privateIp: this.privateIp,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name
        }
      });
    }
  }
};
</script>

<style scoped>
.ElasticBlockStoreDetail-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.host ul {
  list-style: none;
  overflow: hidden;
}
.host ul li {
  float: left;
}
.content > li {
  margin-bottom: 6px;
  border-bottom: 1px dashed #ccc;
  padding: 12px;
}
.content > li:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ebs/ElasticBlockStoreDetail.vue